/**
 * Vrací `true`, pokud jsou zadaná pole ekvivalentní.
 * @param array1
 * @param array2
 * @param isItemEqual Funkce, která rozhoduje o ekvivalenci jednotlivých položek - na stejných indexech.
 */
export const isArrayEqual = <T>(array1: ReadonlyArray<T>, array2: ReadonlyArray<T>, isItemEqual: (item1: T, item2: T) => boolean) => (
    (array2.length === array1.length) && (array1.every((item1, index) => isItemEqual(item1, array2[index])))
);

/**
 * Vrací `true`, pokud obě zadaná pole mají stejný počet prvků a prvky na stejných indexech jsou shodné (tatáž instance).
 * @param array1
 * @param array2
 */
export const isArrayShallowEqual = <T>(array1: ReadonlyArray<T>, array2: ReadonlyArray<T>) => isArrayEqual(array1, array2, Object.is);
